/**
 * Utility functions for role-based access control (RBAC) checking across the application.
 */

export const SYSTEM_BRANCH_ADMIN_ROLES = [
  'BRANCH_ADMIN',
  'BRANCHADMIN',
  'BRANCH_ADMINISTRATOR',
  'ADMIN',
  'SUPERADMIN',
  'SUPER_ADMIN',
  'ORGANIZATIONAL_ADMIN',
  'ORG_ADMIN',
] as const

/**
 * Determines whether a role or user object represents a system Branch Admin (or system organizational admin).
 * Built-in system roles have full access to system configuration (Academic Year, School Profile, Formats, Templates, etc.).
 * Custom roles created via User & Role Management (e.g. Fee Collector, Accountant, Principal, etc.) return false.
 */
export function isBranchAdminRole(
  role?: string | null,
  userMeta?: { role?: string; userType?: string } | null
): boolean {
  if (!role && !userMeta?.role && !userMeta?.userType) return false
  const rawRole = role || userMeta?.role || ''
  const userType = userMeta?.userType || ''
  const normalized = String(rawRole).trim().toUpperCase().replace(/[\s-]/g, '_')
  const normalizedUserType = String(userType).trim().toUpperCase().replace(/[\s-]/g, '_')

  return (
    SYSTEM_BRANCH_ADMIN_ROLES.includes(normalized as any) ||
    SYSTEM_BRANCH_ADMIN_ROLES.includes(normalizedUserType as any)
  )
}

/**
 * Determines whether a role or user object represents an Organizational Admin.
 */
export function isOrganizationAdminRole(
  rawRole?: string | null,
  userMeta?: { role?: string; userType?: string } | null
): boolean {
  if (!rawRole && !userMeta?.role && !userMeta?.userType) return false
  const roleToCheck = rawRole || userMeta?.role || userMeta?.userType || ''
  const norm = String(roleToCheck).trim().toLowerCase()
  return norm === 'organizational_admin' || norm === 'org_admin'
}
